export default "__VITE_ASSET__BA_$UVby__"